export const CREATE_CASE = 'CREATE_CASE';
export const UPDATE_CASE = 'UPDATE_CASE';
export const UPDATE_CASE_WITH_TEMPREF = 'UPDATE_CASE_WITH_TEMPREF';
export const DELETE_PRODUCT_FROM_CASE = 'DELETE_PRODUCT_FROM_CASE';
export const DELETE_CASE = 'DELETE_CASE';
export const SET_CASES = 'SET_CASES';
export const UPDATE_CASE_STATUSES = 'UPDATE_CASE_STATUSES';

export const CREATE_ENTITY = 'CREATE_ENTITY';
export const UPDATE_ENTITY_STATUS = 'UPDATE_ENTITY_STATUS';
export const SET_ENTITY_TO_NO_CONFLICT_STATE = 'SET_ENTITY_TO_NO_CONFLICT_STATE';
export const UPDATE_ENTITY ='UPDATE_ENTITY';
export const UPDATE_ENTITY_WITH_CASEID = 'UPDATE_ENTITY_WITH_CASEID';
export const DELETE_ENTITY = 'DELETE_ENTITY';
export const SET_ENTITIES = 'SET_ENTITIES';
export const UPDATE_ENTITY_NAME = 'UPDATE_ENTITY_NAME';
export const UPDATE_CASE_ENTITY_NAME = 'UPDATE_CASE_ENTITY_NAME';

export const SET_COUNTRY_INFO = 'SET_COUNTRY_INFO';
export const SET_CURRENCY_INFO = 'SET_CURRENCY_INFO';
export const RESET_COUNTRYINFO_DROPDOWN = 'RESET_COUNTRYINFO_DROPDOWN';
export const RESET_CURRENCYINFO_DROPDOWN = 'RESET_CURRENCYINFO_DROPDOWN';
export const SET_COUNTRY_INFO_DATA = 'SET_COUNTRY_INFO_DATA';
export const SET_BANKNAME_INFO ='SET_BANKNAME_INFO';
export const NEW_ENTITIES = 'NEW_ENTITIES';
export const OLD_ENTITIES = 'OLD_ENTITIES';
export const SET_ACCOUNT_PAPERSTATEMENT = 'SET_ACCOUNT_PAPERSTATEMENT';
export const RESET_ACCOUNT_PAPERSTATEMENT = 'RESET_ACCOUNT_PAPERSTATEMENT';


// WEBPACK FOOTER //
// ./src/components/createAcase/actions/actionTypes.js